module.exports = __webpack_public_path__ + "img/00_portada_power.302bf19c.png";